import { SetupChecklist } from '../components/SetupChecklist';
import { VisitorMonitor } from '../components/VisitorMonitor';

export function Dashboard() {
  return (
    <>
      <SetupChecklist />
      <VisitorMonitor />
    </>
  );
}
